import type { ICustomSegmentsUnlockModalTypes } from "pro-features/components/Modals/src/UnlockModal/configs/customSegmentsUnlockModalConfig";
import { CustomSegmentsUnlockModalConfig } from "pro-features/components/Modals/src/UnlockModal/configs/customSegmentsUnlockModalConfig";
import type { SalesUnlockModalConfigType } from "pro-features/components/Modals/src/UnlockModal/configs/salesUnlockModalConfig";
import { createSalesUnlockModalConfig } from "pro-features/components/Modals/src/UnlockModal/configs/salesUnlockModalConfig";
import { i18nFilter } from "app/filters/i18nFilter";
import { AssetsService } from "app/services/AssetsService";

import type { UnlockModalSlides } from "../types";

import type { IAppAnalysisUnlockModalConfigTypes } from "./configs/appAnalysisUnlockModalConfig";
import { AppAnalysisUnlockModalConfig } from "./configs/appAnalysisUnlockModalConfig";
import type { IACAUnlockModalTypes } from "./configs/appCategoryAnalysisUnlockModalConfig";
import { AppCategoryAnalysisUnlockModalConfig } from "./configs/appCategoryAnalysisUnlockModalConfig";
import type { IAKAUnlockModalTypes } from "./configs/appKeywordsAnalysisUnlockModalConfig";
import { AppKeywordsAnalysisUnlockModalConfig } from "./configs/appKeywordsAnalysisUnlockModalConfig";
import type { ICommonUnlockModalConfigTypes } from "./configs/commonUnlockModalConfig";
import { CommonModalConfig } from "./configs/commonUnlockModalConfig";
import type { IConversionUnlockModalTypes } from "./configs/conversionUnlockModalConfig";
import { ConversionUnlockModalConfig } from "./configs/conversionUnlockModalConfig";
import type { ILeadGeneratorUnlockModalTypes } from "./configs/leadGeneratorUnlockModalConfig";
import { LeadGeneratorUnlockModalConfig } from "./configs/leadGeneratorUnlockModalConfig";
import type { IToolsModalConfigTypes } from "./configs/toolsUnlockModalConfig";
import { ToolsUnlockModalConfig } from "./configs/toolsUnlockModalConfig";
import type { ITrackModalConfigTypes } from "./configs/trackUnlockModalConfig";
import { TrackUnlockModalConfig } from "./configs/trackUnlockModalConfig";
import type { IWCAUnlockModalTypes } from "./configs/webCategoryAnalysisUnlockModalConfig";
import { WebCategoryAnalysisUnlockModalConfig } from "./configs/webCategoryAnalysisUnlockModalConfig";
import type { IWKAUnlockModalTypes } from "./configs/webKeywordsAnalysisUnlockModalConfig";
import { WebKeywordsAnalysisUnlockModalConfig } from "./configs/webKeywordsAnalysisUnlockModalConfig";
import type { IWebAnalysisUnlockModalTypes } from "./configs/websiteAnalysisUnlockModalConfig";
import { WebsiteAnalysisUnlockModalConfig } from "./configs/websiteAnalysisUnlockModalConfig";
import type { IWorkspaceModalTypes } from "./configs/workspaceUnlockModalConfig";
import { WorkspaceUnlockModalConfig } from "./configs/workspaceUnlockModalConfig";

interface IModalConfig<T extends keyof IUnlockModalConfigTypes> {
    slides: UnlockModalSlides<IUnlockModalConfigTypes[T]>;
    ctaText: string;
    label: string;
    onCtaClickTrack?: () => void;
}

export type IUnlockModalConfigTypes = ICommonUnlockModalConfigTypes &
    IWCAUnlockModalTypes &
    IWebAnalysisUnlockModalTypes &
    IWKAUnlockModalTypes &
    IAppAnalysisUnlockModalConfigTypes &
    IACAUnlockModalTypes &
    IAKAUnlockModalTypes &
    ILeadGeneratorUnlockModalTypes &
    ITrackModalConfigTypes &
    IToolsModalConfigTypes &
    IConversionUnlockModalTypes &
    ICustomSegmentsUnlockModalTypes &
    IWorkspaceModalTypes &
    SalesUnlockModalConfigType;

type IUnlockConfig = {
    [D in keyof IUnlockModalConfigTypes]: IModalConfig<D>;
};

export type UnlockModalConfigType = keyof IUnlockConfig;

const unlockModalConfig = (): IUnlockConfig => ({
    ...CommonModalConfig(),
    ...WebsiteAnalysisUnlockModalConfig(),
    ...WebCategoryAnalysisUnlockModalConfig(),
    ...WebKeywordsAnalysisUnlockModalConfig(),
    ...AppAnalysisUnlockModalConfig(),
    ...AppCategoryAnalysisUnlockModalConfig(),
    ...AppKeywordsAnalysisUnlockModalConfig(),
    ...LeadGeneratorUnlockModalConfig(),
    ...TrackUnlockModalConfig(),
    ...ToolsUnlockModalConfig(),
    ...ConversionUnlockModalConfig(),
    ...WorkspaceUnlockModalConfig(),
    ...CustomSegmentsUnlockModalConfig(),
    ...createSalesUnlockModalConfig(i18nFilter(), AssetsService),
});
export default unlockModalConfig;
